import {ObligorSearchTableItem} from "../state/obligor-search-table-item";

export class AbstractDocument {
  docLink: string;
  state: string;
}

export interface Filterable {
  selected: boolean;
}

export interface HeaderDetails {
  id: string;
  obligor: Obligor;
  cusip: Cusip;
  proReportDetails: ProReportDetails;
  relatedDocuments: RelatedDocuments;
}

export class Obligor implements ObligorSearchTableItem {
  id: number;
  name: string;
  fye: Date;
  state: string;
  prExists: boolean;
  cdExists: boolean;
  meExists: boolean;
  irisId: number;
  stdState: ReportState;
  proState: ReportState;
  anyRecentFillings: boolean;
  inactive: boolean;
  totalCount: number;

  getObligorId(): number {
    return this.id;
  }

  getProState(): ReportState {
    return this.proState;
  }

  getStdState(): ReportState {
    return this.stdState;
  }

  public setProState(r: ReportState): void {
    this.proState = r;
  }

  public setStdState(r: ReportState): void {
    this.stdState = r;
  }

  public static from(m: Obligor): Obligor {
    const n = new Obligor();
    Object.assign(n, m);
    return n;
  }
}

export interface Cusip {
  id: string;
  name: string;
  datedDate: Date;
  description: string;
  finalMaturity: Date;
  originalPar: string;
  cusipState: string;
  ftpDocPath: string;
  saleDate: Date;
}

export class ProReportDetails {
  comments: string;
  complianceFlags: FlagsModel[];
  diligenceFlags: FlagsModel[];
  mgnInclude: boolean;
  reportGeneratedDate: string;
  reportLastEditedDate: string;
  irisIds: number[];
  deadlines: DocType[];
  mostLeastRestrictiveFilingDeadLines: MostLeastRestrictiveFilingDeadLines;
  searchType: SearchType;
  noDataAvailableMessage: string;
  docKey: string;
  cusipLookupFlag: boolean;
  posUploadFlag: boolean;
}

export interface RelatedDocuments {
  priorDealList: Prior[];
  cdFillingsList: CdFillings[];
  meFillingsList: MeFillings[];
  mgnFillingsList: MuniGuardNews[];
}

export interface FlagsModel {
  flagDescription: string;
  checked: boolean;
}

export interface MostLeastRestrictiveFilingDeadLines {
  mostRestrictiveFilingDeadline: RestrictiveDateDetails;
  leastRestrictiveFilingDeadline: RestrictiveDateDetails;
}

export class Prior extends AbstractDocument implements Filterable, TableView {
  irisId: number;
  cusipId: number;
  datedDate: Date;
  description: string;
  specificDate: Date;
  issuerName: string;
  afsDate: Date;
  summary: boolean;
  complete: boolean;
  daysAfter: number;
  monthsAfter: number;
  finalMaturityDate: Date;
  fsDesc: DocType[];
  daysAfterObligorFye: number;
  obligorId: number;
  fileName: string;
  posFile: boolean;
  posLoading: boolean;
  summaryLoading: boolean;
  completeLoading: boolean;
  docLoading: boolean;

  selected: boolean;

  Doc: string;
  Include: boolean;
  CUSIPs: string;

  get issuerNameDescription(): string {
    return this.issuerName + " / " + this.description;
  }

  public static from(m: Prior): Prior {
    const n = new Prior();
    Object.assign(n, m);
    return n;
  }
}

export interface CdFillings extends AbstractDocument, Filterable, TableView {
  docDate: Date;
  receiveDate: Date;
  docName: string;
  restrictiveFilingDeadline: RestrictiveFilingDeadline;
  fsDesc: DocType[];
  daysBetweenFilingDateAndDocDate: number;
  docId: string;
  cdLoading: boolean;

}

export interface MeFillings extends AbstractDocument, Filterable, TableView, IterableId {
  noticeId: string;
  obligorName: string;
  headline: string;
  receiveDate: Date;
  eventDate: Date;
  daysBetween: number;
  fsDesc: NoticeType[];
  meLoading: boolean;

}

export interface TableView {
  Doc: string;
  Include: boolean;
  CUSIPs: string;
}

export interface MuniGuardNews extends Serializable, Filterable, TableView {
  obligorId: number;
  storyId: number;
  headline: string;
  releaseDate: Date;
  source: string;
}

export interface RestrictiveDateDetails {
  days: number;
  months: number;
  date: string;
}

export interface RestrictiveFilingDeadline {
  min: number;
  max: number;
  anyDatesExist: boolean;
}

export interface Serializable {
}

export class IterableId {
  seq: number;
}

export enum ReportState {
  ACTIVE = "ACTIVE",
  NOT_ACTIVE = "NOT_ACTIVE",
  COMPLETED = "COMPLETED",
  DISABLED = "DISABLED"

}

export enum DocType {
  'OSA' = 'OSA',
  'OS' = 'OS',
  'ESC-A' = 'ESC-A',
  'ESC' = 'ESC',
  'AFS' = 'AFS',
  'CDR' = 'CDR',
  'CAFR' = 'CAFR',
  'Budget' = 'Budget',
  'Int. FS' = 'Int. FS',
  'Stat. FS' = 'Stat. FS',
  'Doc Corr.' = 'Doc Corr.',
  'OS as CDR' = 'OS as CDR',
  'POS' = 'POS',
  'Other' = 'Other',
  'OS as FS (Audited)' = 'OS as FS (Audited)',
  'OS as FS (Unaudited)' = 'OS as FS (Unaudited)'
}

export type SearchType = "CUSIP" | "OBLIGOR" | "UPDATE";

export type NoticeType =
  "Pay. Delinq."
  | "Property"
  | "Rat. Change"
  | "Fail to File"
  | "Other"
  | "Tech Default"
  | "Draws on Reserves"
  | "Draws on Credit"
  | "Change of Credit Providers"
  | "Adv. Tax"
  | "Mod. Rights"
  | "Bond Calls"
  | "Def."
  | "FYE Change"
  | "Tender"
  | "BKRPT"
  | "M&A"
  | "Trustee Change"
  | "Fin. Oblg - Incur. or Agmt"
  | "Fin. Oblg - Fin. Event";
